import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { fetchMemberDuesEligibility } from '@general/api/memberAPI';

const useMemberDuesEligibilityFromAPI = ({ id }) => {
    const [duesOneYear, setDuesOneYear] = useState();
    const [duesThreeYear, setDuesThreeYear] = useState();

    const { data, ...rest } = useQuery(
        `member-dues-eligibility-${id}`,
        async () => {
            const response = await fetchMemberDuesEligibility(id);
            return response?.data?.data || null;
        },
        {
            enabled: !!id,
            staleTime: Infinity,
        }
    );

    useEffect(() => {
        if (!data) {
            return;
        }

        setDuesOneYear(data.dues.find(dues => dues.years === 1));
        setDuesThreeYear(data.dues.find(dues => dues.years === 3));
    }, [data]);

    return { memberDuesEligibility: data, duesOneYear, duesThreeYear, ...rest };
};

export default useMemberDuesEligibilityFromAPI;
